import { OrderItemSerializable } from './order-item-serializable';

export class SfdcAnnualMembershipFeeOrderItemSerializable extends OrderItemSerializable {
  sfdcAnnualMembershipFee: number = null;
}
